<div mat-dialog-content>
  <p>{{ message }}</p>
  <form [formGroup]="publishForm" *ngIf="false">
    <mat-radio-group
      aria-labelledby="example-radio-group-label"
      class="example-radio-group"
      formControlName="schedule"
    >
      <mat-radio-button class="example-radio-button" value="immediate">
        Publish Immediatly
      </mat-radio-button>
      <mat-radio-button class="example-radio-button" value="schedule">
        Schedule Publish
      </mat-radio-button>
    </mat-radio-group>

    <div *ngIf="publishForm.get('schedule').value == 'schedule'">
      <mat-form-field appearance="fill" style="width: 100%">
        <input
          matInput
          readonly
          [matDatepicker]="picker"
          (click)="picker.open()"
          formControlName="date"
          name="date"
          required="true"
          placeholder="Select a Date"
          [min]="today"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
  </form>
  <div class="detail">{{ messageDetail }}</div>
  <ul>
    <li *ngFor="let item of details">{{ item }}</li>
  </ul>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close class="button_small cancel">
    cancel
  </button>
  <button mat-button class="button_small" (click)="onConfirmClick()">
    {{ actionButton }}
  </button>
</div>
